import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0549',
    ecrans: ['00-2'],
    params: ['?pgpcleint', '?rprdatpai']
});
